import PropTypes, { element } from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import BaseDialogContainer from '../baseContainers/BaseDialogContainer';
import {ActionButton} from '../components/ActionButton';
import DivContainer from '../components/DivContainer';
import InputTextComponent from '../components/inputs/InputTextComponent';
import PhoneNumberComponent from '../components/PhoneNumberComponent';
import CardDataModel from '../model/CardDataModel';
import CardService from '../services/CardService';
import SettingService from '../services/SettingService';
import InputDropdownComponent from '../components/inputs/InputDropdownComponent';
import InputCheckboxComponent from '../components/inputs/InputCheckboxComponent';
class CardDataEditDialog extends BaseDialogContainer {
    constructor(props) {
        super(props, new CardService());
        this.settingService = new SettingService();
        this.state = {
            element: new CardDataModel(),
            telephoneCodeOptions: [],
            viewMode: this.props.viewMode,
            approvals: this.props.agreementsToAccept,
            acceptedTerms: {},
            limitedAccessOpt: [{enumValue : "YES", label: "Tak"}, {enumValue: "NO", label: "Nie"}]
        };
    }

    initBeforeSetElement() {
        this.settingService
            .getTelephoneCodeList()
            .then((telephoneCodeOptions) => {
                if (this._isMounted) {
                    this.setState({
                        telephoneCodeOptions: telephoneCodeOptions,
                    });
                }
            })
            .catch(() => {});
    }

    componentDidUpdate(prevProps, prevState) {
        super.componentDidUpdate(prevProps, prevState);
        if (!prevProps.visible && this.props.visible) {
            this.setElement();
        }
    }

    prepareFooter() {
        const {t} = this.props;
        return (
            <div className='footer-dialog-button-container'>
                <ActionButton label={t('details.cancel')} variant={'button cancel-button white'} handleClick={this.props.onHide} />
                <ActionButton label={t('details.saveChanges')} variant='button save-button blue' handleClick={this.handleFormSubmit} />
            </div>
        );
    }

    renderHeader() {
        const {t} = this.props;
        return (
            <DivContainer colClass='col-12 transaction-dialog-header'>
                <DivContainer colClass='col-12'>
                    <label>{t('details.editButton')}</label>
                </DivContainer>
            </DivContainer>
        );
    }
    updateElement(data) {
        if (data.phoneNumber !== undefined && data.phoneNumber !== null && data.phoneNumber.startsWith('(')) {
            let prefix = data.phoneNumber.substring(0, data.phoneNumber.indexOf(')') + 1);
            if (prefix !== undefined) {
                this.state.telephoneCodeOptions.forEach((element) => {
                    if (prefix === element.code) {
                        data.phoneNumberCode = element;
                        data.phoneNumberValue = data.phoneNumber.substring(data.phoneNumber.indexOf(')') + 1);
                    }
                });
            }
        }
        if(data.vehicleType !== undefined && data.vehicleType !== null){
            data.vehicleType = this.props.vehicleTypeOpt.find(el => el.code === data.vehicleType);
        }
        if(data.limitedAccess !== undefined && data.limitedAccess !== null){
            data.limitedAccess = data.limitedAccess === true ? this.state.limitedAccessOpt.find(el => el.enumValue === "YES") : this.state.limitedAccessOpt.find(el => el.enumValue === "NO");
        }
        this.setState(
            {
                element: CardDataModel.copy(data),
            },
            () => {
                this.initAfterSetElement();
            }
        );
    }
    setElement() {
        if (this.props.element) {
            this.updateElement(this.props.element);
        }
    }
    getContainerListName() {
        return 'driver-list-container';
    }

    getAddSucces() {
        return 'Osoba kontaktowa została utworzona';
    }

    getUpdateSucces() {
        return 'Osoba kontaktowa została zaktualizowana';
    }
    createOrUpdate() {
        const {element, acceptedTerms} = this.state;
        const acceptedApprovals = this.state.approvals.filter(a => acceptedTerms[a.approvalType] == true);
        const simplifiedAcceptedTermsToSend = acceptedApprovals.map(({petraAgreementId, approvalType, accepted }) => ({petraAgreementId, approvalType,accepted}));
        element.cards = this.props.cardNumbers;
        element.acceptedTerms = simplifiedAcceptedTermsToSend;
        if (
            element.phoneNumberCode !== undefined &&
            element.phoneNumberCode !== null &&
            element.phoneNumberValue !== undefined &&
            element.phoneNumberValue !== null &&
            element.phoneNumberValue !== ''
        ) {
            element.phoneNumber = element.phoneNumberCode.code + element.phoneNumberValue;
        } else {
            element.phoneNumber = '';
        }
        if(element.vehicleType !== undefined){
            element.vehicleType = element.vehicleType.code;
        }
        if(element.limitedAccess !== null){
            element.limitedAccess = element.limitedAccess?.enumValue === "YES" ? true : false;
        }
        this.scrollToTop();
        if (this.props._isMounted) {
            this.service
                .updateCardData(element)
                .then((response) => {
                    this.blockUi();
                    if (this.props.handleSuccess) {
                        this.props.handleSuccess(response);
                    }
                })
                .catch((err) => {
                    this.unblockUi();
                    if (this.props.handleError) {
                        this.props.handleError();
                    }
                });
        }
    }
    translate(key) {
        const {t} = this.props;
        return t(key);
    }
    renderDetails() {
        const {t} = this.props;
        const limitedAccess = this.authService.getProfile().limitedAccess === true ? true : false;
        this.state.element.phoneNumberCode = this.state.element.phoneNumberCode === undefined ? this.state.telephoneCodeOptions[0] : this.state.element.phoneNumberCode;
        return (
            <React.Fragment>
                <div className='row row-24'>
                    <PhoneNumberComponent
                        id='phoneNumber-dialog'
                        nameCode='phoneNumberCode'
                        namePhoneNumber='phoneNumberValue'
                        labelCode={t('cards.phoneNumberCode')}
                        labelPhoneNumber={t('cards.phoneNumber')}
                        colClass='col-xl-4 col-lg-4 col-md-8 col-sm-12'
                        phoneCodeValue={this.state.element.phoneNumberCode}
                        phoneNumberValue={this.state.element.phoneNumberValue}
                        telephoneCodeOptions={this.state.telephoneCodeOptions}
                        value={this.state.element.phoneNumber}
                        viewMode='EDIT'
                        onChange={this.handleChange}
                        validator={this.validator}
                        renderRequired
                        required={false}
                        disabled={this.state.element?.dontResume === true}
                    />
                    {/* <InputTextComponent
                        id='driver-dialog'
                        name='driver'
                        label={t('cards.fullName')}
                        colClass='col-xl-4 col-lg-4 col-md-4 col-sm-12'
                        value={this.state.element.driver}
                        viewMode='EDIT'
                        onChange={this.handleChange}
                        validators={'not_required|max:100'}
                        validator={this.validator}
                        renderRequired
                        rendered={this.props?.cardKind === 'FIRM'}
                    />
                    <InputTextComponent
                        id='registrationNumber-dialog'
                        name='registrationNumber'
                        label={t('cards.registrationNumberFull')}
                        colClass='col-xl-4 col-lg-4 col-md-4 col-sm-12'
                        value={this.state.element.registrationNumber}
                        viewMode='EDIT'
                        onChange={this.handleChange}
                        validators={'not_required|alpha_num|max:10'}
                        validator={this.validator}
                        renderRequired
                        rendered={this.props?.cardKind === 'FIRM'}
                        forceUpperCase
                        keyfilter={/^[A-Z0-9]*$/i}
                    /> */}
                    <InputTextComponent
                        id='mpk-dialog'
                        name='mpk'
                        label={t('cards.mpk')}
                        colClass={limitedAccess ? 'col-xl-2 col-lg-2 col-md-2 col-sm-12' : 'col-xl-4 col-lg-4 col-md-4 col-sm-12'}
                        value={this.state.element.mpk}
                        viewMode='EDIT'
                        onChange={this.handleChange}
                        max={20}
                        validators='not_required|numeric|max:20'
                        validator={this.validator}
                        keyfilter={/^[0-9]*$/i}
                    />
                     <InputDropdownComponent
                            id='vehicleType'
                            name='vehicleType'
                            label={t('cards.vehicleType')}
                            colClass={ limitedAccess ? 'col-xl-3 col-lg-3 col-md-3 col-sm-12' : 'col-xl-4 col-lg-4 col-md-4 col-sm-12'}
                            value={this.state.element.vehicleType}
                            validator={this.validator}
                            options={this.props.vehicleTypeOpt}
                            onChange={this.handleChange}
                            viewMode={'EDIT'}
                            optionLabel='label'
                            dataKey='code'
                            validators='required'
                            renderRequired
                        />  
                       { limitedAccess ? 
                           <InputDropdownComponent
                            id='limitedAccess'
                            name='limitedAccess'
                            label={t('cards.limitedAccess')}
                            colClass={'col-xl-3 col-lg-3 col-md-3 col-sm-12'}
                            value={this.state.element.limitedAccess}
                            validator={this.validator}
                            options={this.state.limitedAccessOpt}
                            onChange={this.handleChange}
                            viewMode={'EDIT'}
                            optionLabel='label'
                            dataKey='enumValue'
                            validators='not_required'
                        />  : null}
                        {/* { limitedAccess ? 
                                                    <InputCheckboxComponent
                                                    id='limitedAccess'
                                                    name='limitedAccess'
                                                    label={t('cards.limitedAccess')}
                                                    labelOnRight
                                                    value={this.state.element.limitedAccess}
                                                    onChange={(a,b,c,d,e)=> {
                                                        this.handleChange(a,b,c,d,e)}}
                                                    validator={this.validator}
                                                    viewMode='NEW'
                                                    validators='not_required'
                                                    colClass='col-3 limited-access'
                                                    //colClass='col-width-auto'
                                                /> : null} */}
        
                                                                 
                                                                         
                </div>
                <div className='row' style={{marginTop:'15px'}}>
                      {this.authService.getAgreementSourceTypeFromToken() === 'SGB_BANK' || this.authService.getAgreementSourceTypeFromToken() === 'BPS_BANK' ? 
                                       this.state.approvals?.map((approval, index) => {
                                            const label = approval.contents
                                                .map((str) => {
                                                    return str.type === 'TRANSLATE'
                                                        ? t(`${str.content}`)
                                                        : `<a href="${str.linkUrl}" target="_blank">${t(str.linkLabel)}</a> `;
                                                })
                                                .join('');
                                            return (
                                                <div>
                                                <InputCheckboxComponent
                                                    id={`approval-${approval.approvalType}`}
                                                    name={`${approval.approvalType}`}
                                                    label={label}
                                                    labelOnRight
                                                    value={this.state.acceptedTerms[`${approval.approvalType}`]}
                                                    onChange={this.handleChange}
                                                    stateField={`acceptedTerms`}
                                                    validator={this.validator}
                                                    viewMode='NEW'
                                                    colClass='col-12'
                                                    labelClassName='hybrid-approval-content-title'
                                                    required={!!approval.required}
                                                    renderRequired={!!approval.required}
                                                    validatorLabel=''
                                                    onAfterStateChange={() => { }}
                                                    validators = {'required|checkbox_checked_required'}
                                                    
                                                />
                                     
                                                </div>
                                                
                                            );
                                        }) : null} 
                </div>
            </React.Fragment>
        );
    }
}

CardDataEditDialog.defaultProps = {
    currentUser: undefined,
    viewMode: 'EDIT',
    visible: false,
};

CardDataEditDialog.propTypes = {
    backUrl: PropTypes.string,
    cancelUrl: PropTypes.string,
    currentUser: PropTypes.object,
    editUrl: PropTypes.string,
    viewMode: PropTypes.string,
    visible: PropTypes.bool,
    onHide: PropTypes.func,
    afterSave: PropTypes.func,
    cardNumbers: PropTypes.array,
    vehicleTypeOpt: PropTypes.array,
    agreementsToAccept: PropTypes.array,
};

export default withTranslation()(CardDataEditDialog);
